import { createLazyComponent, LazyModule } from 'owa-bundling';

const lazyModule = new LazyModule(
    () => import(/* webpackChunkName: "LocationCard"*/ './lazyIndex')
);

// Delayed Loaded Components
export const LocationCard = createLazyComponent(lazyModule, m => m.LocationCard);
export const LocationCompactCard = createLazyComponent(lazyModule, m => m.LocationCompactCard);
export const LocationExpandedCard = createLazyComponent(lazyModule, m => m.LocationExpandedCard);

// Non-lazy actions (for subscription only)
export { onLocationDetailsLoaded } from './actions/locationCardActions';
